import Vue from "vue";

Vue.component("related-notifications", {
	props: ["documentSymbol", "searchUrl", 'includeOriginal'],
	data() {
		return {
			showRelatedNotificationDetails: false,
			relatedNotificationViewModel: {},
			relatedNotifications: [],
			loading: true
		};
	},
	computed: {
		relatedNotificationsLabel() {
			return htmlEntity.decode(window.labels.relatedNotifications);
		},
		closeLabel() {
			return window.labels.closeText;
		},
		loadingText() {
			return window.labels.loading + "..";
		},
		dolLinkUrl() {
			return '/' + window.currentLanguage + '/DOL/GetDocument';
		},
	},
	methods: {
		showRelatedNotificationDataDetails: function (documentSymbol) {
			this.$services.notifications.getViewNotification({ documentSymbol: documentSymbol })
				.then((response) => {
					let pdfUrl = null;
					if (response.dolLink) {
						const docs = response.dolLink.replace(/\\/g, "/");
						const symbol = docs.split('.');
						pdfUrl = `${window.location.origin}/viewer/web/viewer.html?file=` + escape(`${this.dolLinkUrl}?dolLink=${symbol[0]}&notificationId=${response.id}`);
					}
					this.relatedNotificationViewModel = {
						id: response.id,
						dolLink: pdfUrl,
						symbol: response.documentSymbol,
						domain: response.domain,
						countryId: response.countryId
					};

					this.showRelatedNotificationDetails = true;
				});
		},
	},
	mounted() {
		this.loading = true;
		this.$services.notifications.getRelatedNotifications({
			documentSymbol: this.documentSymbol,
			includeOriginal: this.includeOriginal ? true : false
		})
			.then((data) => {
				this.loading = false;
				this.relatedNotifications = data;
			});
	},
	template: `
      <div>
      	<div v-if="loading">
	        <loading :loading-text="loadingText"></loading>
      	</div>
      	<div v-else-if="relatedNotifications && relatedNotifications.length > 0" class="column is-full pt-0 pb-1 pl-0">
		  <strong>{{ relatedNotificationsLabel }}</strong>:
		  <a v-for="(item, index) in relatedNotifications" v-bind:key="item" class="symbol-link" @click="showRelatedNotificationDataDetails(item)">{{ item }}
			<span v-if="relatedNotifications.length > 1 && relatedNotifications.length -1 !== index">, </span>
		  </a>
		</div>
		<b-modal v-model="showRelatedNotificationDetails" #default="props">
			<div class="modal-card" style="width: 100% !important; height: 100% !important">
				<header class="modal-card-head">
					<p class="modal-card-title truncate-overflow-1" :title="relatedNotificationViewModel.symbol">{{ relatedNotificationViewModel.symbol }}</p>
				</header>
				<section class="modal-card-body">
					<div class="columns" style="height: 100%; display: flex; flex-direction: column;">
						<div style="position: relative">
							<div class="column is-full pt-0 pb-1 pl-0">&nbsp;</div>
							<notification-download-document :notification-id="relatedNotificationViewModel.id"></notification-download-document>
						</div>
						<div class="column is-full m-0 p-0" style="flex: 1;" v-if="relatedNotificationViewModel.dolLink">
							<iframe :src="relatedNotificationViewModel.dolLink" style="height: 100%; width: 100%"></iframe>
						</div>
					</div>
				</section>
				<footer class="modal-card-foot buttons is-right">
					<b-button :label="closeLabel" @click="props.close"></b-button>
				</footer>
			</div>
		</b-modal>
	  </div>
	`,
});